// Debugging confirmation
console.log('✅ state.js loaded successfully!');

// // Import configuration constants
import { APP_CONFIG, PERSISTENT_KEYS } from './config.js'; // ✅ PERSISTENT_KEYS are Set of keys that should persist across sessions

function generateUuidV4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}




let internalAppState = {
    // ... your existing state properties here
    BASE_URL: '/',
    MyAppStartUpAppUserIsAuthenticated: false,
    LoginRefreshToken: '',
    MyUserIsAuthenticated: false,

    JWTAccessToken: '',
    JWTRefreshToken: '',

    MyLoggedInUserID: '',
    MyLoggedInUserEmail: '',
    MyBuyingEntityID: '',
    MyBuyingEntityType: '',
    MyBuyingEntityCompanyName: 'CompanyName',

 
    MyUserFirstName: 'FirstName',
    MyUserLastName: 'LastName',

    currentUserModel: {
        CustomerPreferredPaymentProvider: '', // e.g. "PayPal" or "Card"
        PaymentLast4: '', // last 4 digits of card
        PhoneNumber1: '',
        PhoneNumberCallingCode1Display: '',
        PhoneNumber2: '',
        PhoneNumberCallingCode2Display: '',
        // ...and so on for address, etc.
    },

    currentUserDefaultAddress: {
        AddressID: 0,
        AddressLine1: '',
        AddressLine2: '',
        AddressCityIDDisplay: '',
        AddressStateIDDisplay: '',
        AddressCountryIDDisplay: '',
        AddressPostCode: '',
    },

    UserHasAtLeastOneBuyingCompanyAccess: false,
    SiteIsInDevMode: false,

    // Last visited pages
    MyUserLastPageVisited: '',
    MyUserLastPageVisitedListing: '',
    MyUserLastPageVisitedProduct: '',
    MyUserLastPageVisitedCategory: '',
    MyUserLastPageVisitedDepartment: '',

    // Screen Size
    MyUserPageHeight: '',
    MyUserPageWidth: '',

    // User Context
    MyUserRemoteIpAddress: '',
    MyUserHeadersUserAgent: '',
    MyUserTypedHeadersAcceptLanguages: [],

    // Site Preferences
    SiteBuyingEntityIDCookie: '',
    SiteLanguageCookie: 'en',
    SiteCurrencyCodeCookie: 'USD',

    SiteShipToCountryIDCookie: '237',
    SiteShipToStateIDCookie: '0',
    SiteShipToCityIDCookie: '0',
    SiteShipToCountryCodeTwoCookie: 'gb',
    SiteShipToCountryCodeThreeCookie: 'GBR',
    SiteShipToCountryNameCookie: 'United Kingdom',
    SiteCurrencyCodeCookie: 'USD',
    SiteCurrencyRateCookie: '1.00',
    SiteCurrencySignSingleCookie: '$',
    SiteCurrencySignMultipleCookie: '$',

    GDPRConsentSetCookie: false,
    GDPRPreferences: true,
    GDPRStatistics: true,
    GDPRMarketing: true,

    MyValueSelectedBlogHeaderCategoryID: '',

    SearchSettingsSortBy: 'relevance',
    SearchSettingsItemsPerPage: '6',
    SearchSettingsGroupRelated: true,

    SearchFilters: {
        //pularl format for simplisity and to match checkboxes
        ckListAllAppliedFilters: false,
        ckListAllCategories: false,
        ckListAllSubcategories: false,
        ckListAllProducts: false,
        ckListAllSupplierTypes: false,
        ckListAllSellerLevels: false,
        ckListAllBuyTypes: false,
    },
    ListOfSpecOptionsSelectedFilters: [],

    PhoneNumberCallingCodeID1: 240,
    PhoneNumberCallingCodeID2: 240,


    BuyingCompanyInEditModeID: '',
    MyValueContactUsPageIssueID: '',

};



export const appState = new Proxy(internalAppState, {
    set(target, key, value) {
        const oldValue = target[key];

        if (oldValue !== value) {
            target[key] = value;

            if (!isNodeEnvironment()) {

                triggerAppStateWatchers(key, value);
                //// Optional: persist value
                if (PERSISTENT_KEYS.has(key)) {
                    localStorage.setItem(key, JSON.stringify(value));
                }

            }
        }

        return true;
    },
    get(target, key) {
        return target[key];
    }
});


const appStateWatchers = {};

export function watchAppState(key, callback) {
    if (!appStateWatchers[key]) {
        appStateWatchers[key] = [];
    }
    appStateWatchers[key].push(callback);
}

function triggerAppStateWatchers(key, value) {
    if (Array.isArray(appStateWatchers[key])) {
        for (const cb of appStateWatchers[key]) {
            cb(value);
        }
    }
}


// Get state by key
export function getAppStateValueByKey(key) {
  return appState.hasOwnProperty(key) ? appState[key] : null;
}

// Update state and persist in local storage if needed
export function setAppStateValueByKey(key, value) {
  if (appState.hasOwnProperty(key)) {
    appState[key] = value;

    if (PERSISTENT_KEYS.has(key)) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }
}

export function setNestedAppStateValueByKey(group, key, value) {
  if (appState.hasOwnProperty(group) && typeof appState[group] === 'object') {
    appState[group][key] = value;

    //   alert(`Updating ${group} -> ${key} to ${value}`);

    // Only persist the specific nested object (like SearchFilters), not the whole appState
    if (PERSISTENT_KEYS.has(group)) {
      localStorage.setItem(group, JSON.stringify(appState[group]));
    }
  }
}

// Load state from local storage on initialization
export function loadPersistentState() {
  PERSISTENT_KEYS.forEach(key => {
    const storedValue = localStorage.getItem(key);

    if (storedValue !== null && storedValue !== 'undefined') {
      try {
        appState[key] = JSON.parse(storedValue);
      } catch (e) {
        console.error(`Failed to parse state for ${key}:`, e);
      }
    }
  });

  // Now guarantee we have a user ID
  if (!appState.MyLoggedInUserID) {
    // // use WebCrypto if available, else fallback
    //const newId = (crypto.randomUUID?.() ?? generateUuidV4());
    const randomUserID =
      typeof crypto === 'object' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : generateUuidV4();

    appState.MyLoggedInUserID = randomUserID;
    appState.MyBuyingEntityID = randomUserID;
    appState.MyBuyingEntityType = 'Guest';
    appState.MyBuyingEntityCompanyName = 'CompanyName';

    // Persist them immediately
    setAppStateValueByKey('MyLoggedInUserID', randomUserID);
    setAppStateValueByKey('MyBuyingEntityID', randomUserID);
    setAppStateValueByKey('MyBuyingEntityType', 'Guest');
    setAppStateValueByKey('MyBuyingEntityCompanyName', 'CompanyName');
  }
}

export function isValidLanguage(lang) {
  return APP_CONFIG.VALID_LANGUAGE_CODES.includes(lang);
}

export function getValidLanguageFromAppState() {
  let lang = getAppStateValueByKey('SiteLanguageCookie');
  return isValidLanguage(lang) ? lang : null;
}

function isNodeEnvironment() {
  return typeof process !== 'undefined' && process.versions && process.versions.node;
}

export function setValidLanguageToAppState(lang) {
  if (isValidLanguage(lang)) {
    if (isNodeEnvironment()) {
      // Node.js environment do nothing
    } else {
      setAppStateValueByKey('SiteLanguageCookie', lang);
    }
  } else {
    console.warn(`Invalid language code: ${lang}`);
  }
}

// getArrowDownIconSVG.js
export function getArrowToggleDownIconSVG(className = '', size = 24) {
  return `
    <svg fill="#555" height="${size}px" width="${size}px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="${className}">
      <path d="M13.708 6.29A1.006 1.006 0 0 0 13 6H5.005A1 1 0 0 0 4.3 7.71l4 4a1.013 1.013 0 0 0 1.42 0l4-4a1.01 1.01 0 0 0-.013-1.42z"/>
    </svg>`;
}
